// Use network IP from current hostname (works when accessed via QR code)
// If accessed via localhost, use localhost; if via IP, use that IP
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  const hostname = window.location.hostname;
  const port = '5000';

  if (hostname === 'vc-arena.innovis.vc' || hostname.includes('innovis.vc')) {
    return '/api';
  }
  
  // If hostname is localhost or 127.0.0.1, use localhost
  // Otherwise use the hostname (network IP when accessed via QR code)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://localhost:${port}/api`;
  }
  
  return `http://${hostname}:${port}/api`;
};

const API_BASE_URL = getApiBaseUrl();

export default API_BASE_URL;
